import { Component, Input } from "@angular/core";
import * as moment from "moment";

@Component({
  selector: "mar-tile",
  templateUrl: "mar-tile.html",
})
export class MarTileComponent {
  createdDatetime: string;
  dosage: string;
  administrator: string;
  administered: boolean;

  selected = false;

  @Input() data: any = {};

  constructor() {}

  ngOnInit() {
    this.createdDatetime = this.data.createdDatetime;
    this.dosage = this.data.dosage;
    this.administrator = this.data.createdBy
      ? this.data.createdBy.username
      : "";
    this.administered = this.data.administered;
  }

  formatTime(input) {
    return moment.utc(input).local().format("h:mma");
  }
}



// WEBPACK FOOTER //
// ./src/components/medication-administration-records/mar-tile/mar-tile.ts